import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app";
import { Providers } from "@/components/atoms/providers";
import "@/i18n";
import "@/styles/index.css";
import "@/styles/tailwind/index.css";
import "@/utils/polyfills/crypto-random-uuids";
import "@/utils/polyfills/form-request-submit";

defineCustomElements(window);

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);
